var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px" },
          model: {
            value: _vm.contextDialog,
            callback: function($$v) {
              _vm.contextDialog = $$v
            },
            expression: "contextDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticStyle: { overflow: "hidden" } },
            [
              _c(
                "v-card-text",
                { staticStyle: { height: "305px" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-radio-group",
                        {
                          attrs: { row: "" },
                          model: {
                            value: _vm.extension,
                            callback: function($$v) {
                              _vm.extension = $$v
                            },
                            expression: "extension"
                          }
                        },
                        [
                          _c("v-radio", {
                            attrs: { label: "PDF", value: "PDF" }
                          }),
                          _c("v-radio", {
                            attrs: { label: "CSV", value: "CSV" }
                          }),
                          _c("v-radio", {
                            attrs: { label: "HTML", value: "HTML" }
                          }),
                          _c("v-radio", {
                            attrs: { label: "XLS", value: "XLS" }
                          }),
                          _c("v-radio", {
                            attrs: { label: "XLSX", value: "XLSX" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      !_vm.$store.getters["Ajax/loading"]
                        ? [
                            _c(
                              "v-col",
                              {
                                staticClass: "report-flex",
                                attrs: { cols: "6" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "pa-4 text-md-center elevation-5 ma-3 report-buttons",
                                    on: { click: _vm.downloadGroups }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { "padding-left": "45px" }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticStyle: {
                                              "font-size": "80px"
                                            },
                                            attrs: { color: "primary" }
                                          },
                                          [_vm._v("view_agenda")]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            staticStyle: {
                                              position: "relative",
                                              right: "25px",
                                              top: "20px"
                                            },
                                            attrs: {
                                              "x-small": "",
                                              fab: "",
                                              color: "success"
                                            }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v("cloud_download")
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c("h3", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("global.downloadGroupsOnly")
                                          ) +
                                          " "
                                      )
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "report-flex",
                                attrs: { cols: "6" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "pa-4 text-md-center elevation-5 ma-3 report-buttons",
                                    on: { click: _vm.downloadDetailed }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { "padding-left": "45px" }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticStyle: {
                                              "font-size": "80px"
                                            },
                                            attrs: { color: "primary" }
                                          },
                                          [_vm._v("view_headline")]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            staticStyle: {
                                              position: "relative",
                                              right: "25px",
                                              top: "20px"
                                            },
                                            attrs: {
                                              "x-small": "",
                                              color: "success",
                                              fab: ""
                                            }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v("cloud_download")
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c("h3", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("global.downloadDetailed")
                                          ) +
                                          " "
                                      )
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("v-checkbox", {
                                  attrs: {
                                    label: _vm.$t("booking.addSummaryRow")
                                  },
                                  model: {
                                    value: _vm.isSummary,
                                    callback: function($$v) {
                                      _vm.isSummary = $$v
                                    },
                                    expression: "isSummary"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm.$store.getters["Ajax/loading"]
                        ? _c(
                            "v-col",
                            {
                              staticStyle: { "text-align": "center" },
                              attrs: { cols: "12" }
                            },
                            [
                              _c("v-progress-circular", {
                                attrs: {
                                  indeterminate: "",
                                  color: "primary",
                                  size: "105"
                                }
                              }),
                              _c("h3", { staticClass: "mt-4" }, [
                                _vm._v(_vm._s(_vm.$t("global.generating")))
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.contextDialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }